import axios from 'axios'
export default {
    namespaced: true,
    state: {
		endpoint: '/vehicle/category/brand/model/year',
        items: [],
    },
    actions: {
		load (context, param) {
			return axios.get(`/vehicle/model/${param.model.id}/years`).then(response => {
				//console.log('VehicleBrandModelYear', 'load','response.data', response.data)
				context.commit('items', response.data)
			}, error => {
				console.log(error)
			})
		},
    }
}